<template>
    <div name="agreement" class="agreement">       
        <img class="back-button" src="../../../assets/arrow_back.png" @click="back" />
        <span class="text1" style="margin-top: 26px;">솔닥 서비스 이용을 위해<br><span class="text1-bold">약관 동의가 필요해요</span></span>
        <!-- agree area -->
        <div class="agree-area">
            <div class="all-agree" ref="agree" >
                <check-box 
                    :checked="allAgree"
                    @onClick="allAgreeFunction"
                />
                <span @click="allAgreeFunction" class="all-agree-text">모두 동의합니다.</span>
            </div>

            <div class="agree-detail-box" style="margin-top: 30px;">
                <div class="row">
                    <check-box 
                        :checked="agreement_terms_condition_description"
                        @onClick="() => {agreement_terms_condition_description = !agreement_terms_condition_description}"
                    />
                    <span class="agree-text">[필수] 서비스 이용약관 동의</span>
                </div>

                <img style="width: 20px;cursor: pointer;" @click="openPolicy(1)" src="../../../assets/detail.png" />
            </div>
            <div class="agree-detail-box" style="margin-top: 20px;">
                <div class="row">
                    <check-box 
                        :checked="agreement_personal_info"
                        @onClick="() => {agreement_personal_info = !agreement_personal_info}"
                    />
                    <span class="agree-text">[필수] 개인정보 수집 및 이용 동의</span>
                </div>
                <img style="width: 20px;cursor: pointer;" @click="openPolicy(2)" src="../../../assets/detail.png" />
            </div>
            <div class="agree-detail-box" style="margin-top: 20px;">
                <div class="row">
                    <check-box 
                        :checked="agreement_marketing"
                        @onClick="() => {agreement_marketing = !agreement_marketing}"
                    />
                    <span class="agree-text">[선택] 개인정보 마케팅 활용 동의</span>                        
                </div>                    
                <img style="width: 20px;cursor: pointer;" @click="openPolicy(4)" src="../../../assets/detail.png" />
            </div>
            <div class="agree-detail-box" style="margin-top: 14px; margin-bottom: 40px">
                <div class="col" v-if="!agreement_marketing">
                    <div class="row">
                        <img src="../../../assets/check_no_outline_inactive.png" style="width: 22px; margin-right: 14px;" />
                        <span>이벤트•혜택 알림 동의</span>
                    </div>
                    <span class="red-text" style="margin-top: 4px;">솔닥 혜택 정보를 받으시려면 ‘마케팅 활용’에 동의해 주세요.</span>
                </div>
                <div class="row" v-else>
                    <img src="../../../assets/check_no_outline_active.png" style="width: 22px; margin-right: 14px;" />
                    <span>이벤트•혜택 알림 동의</span>
                </div>
            </div>
        </div>
        <!-- agree area -->
        <!-- buttons -->
        <div class="button-position" v-show="!agreement_terms_condition_description || !agreement_personal_info">
            <bottom-button                 
                :text="'가입 완료'"
                :color="'#EDEEF0'"
                @onClick="()=>{}"
            />
        </div>
        <div class="button-position" v-show="agreement_terms_condition_description && agreement_personal_info">
            <bottom-button 
                :text="'가입 완료'"
                :color="'#000'"
                @onClick="signComplete"
            />
        </div>
        
    </div>
</template>

<script>
import CheckBox from '@/components/atoms/CheckBox';
import BottomButton from '@/components/atoms/BottomButton';

export default {
    name: 'agreement',
    components: {
        CheckBox,
        BottomButton
    },
    data: function() {
        return {
            agreement_terms_condition_description: false,
            agreement_personal_info: false,
            agreement_marketing: false,
            allAgree: false
        }
    },
    methods: {
        allAgreeFunction: function()
        {
            this.allAgree = !this.allAgree;
        },
        openPolicy: function(index)
        {   
            if(index === 1)
            {
                window.open("https://policy.soldoc.co.kr/terms", '_blank')
            }
            else if(index === 2)
            {
                window.open("https://policy.soldoc.co.kr/privacy-consent/signup", '_blank')
            }
            else if(index === 3)
            {
                window.open("https://policy.soldoc.co.kr/use", '_blank')
            }
            else if(index === 4)
            {
                window.open("https://policy.soldoc.co.kr/marketing", '_blank')
            }
        },
        signComplete: function()
        {
            this.$emit('completeSign', this.agreement_terms_condition_description, this.agreement_personal_info, this.agreement_marketing);
        },
        back: function()
        {
            this.$emit('close')
        }
    },
    watch: {
        allAgree: function()
        {
            this.agreement_personal_info = this.allAgree;
            this.agreement_terms_condition_description = this.allAgree;
            this.agreement_marketing = this.allAgree;
        }
    }
    
}
</script>

<style scoped>
    .agreement {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 16px 16px 30px 16px;
        height: 100vh;
        position: relative;
    }
    .back-button {
        width: 22px;
        cursor: pointer;
    }
    .text1 {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px; /* 140% */
    }
    .text1-bold {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
    }

    .agree-area {
        width: 100%;
    }

    .all-agree {
        height: 57px;
        flex-shrink: 0;
        width: calc(100%);
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        padding-left: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        margin-top: 30px;
        box-sizing: border-box;
    }
    .all-agree-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 100% */
        cursor: pointer;
        margin-left: 17px;
    }
    .agree-detail-box {
        padding-left: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100%);
        box-sizing: border-box;
    }
    .agree-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        margin-left: 17px;
    }
    .row {
        display: flex;
    }
    .col {
        display: flex;
        flex-direction: column;
    }
    .red-text {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .button-position {
        position: absolute;
        width: 100%;
        bottom: 30px;
        left: 50%;
        transform: translate(-50%, 0);
    }

    @media (min-width: 600px) {
        .agreement {
            width: 600px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/contract/Agreement.vue